'use client';

import { PublicPageLayout } from '@letsgo/PublicPageLayout';
import Link from 'next/link';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import type { BlogPost } from '@/content/blog/posts';

function formatDate(dateStr: string): string {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export function BlogPostView({ post }: { post: BlogPost }) {
  const paragraphs = post.body.trim().split(/\n\n+/).filter(Boolean);

  return (
    <PublicPageLayout>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <MuiLink component={Link} href="/blog" color="primary" sx={{ display: 'inline-block', mb: 2, fontWeight: 600 }}>
          ← Back to Blog
        </MuiLink>
        <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
          {formatDate(post.date)}
        </Typography>
        <Typography variant="h4" component="h1" fontWeight={700} mb={2} color="text.primary">
          {post.title}
        </Typography>
        <Box sx={{ '& p': { mb: 2 } }}>
          {paragraphs.map((para, i) => (
            <Typography key={i} variant="body1" color="text.primary" component="p">
              {para}
            </Typography>
          ))}
        </Box>
        <MuiLink component={Link} href="/blog" color="primary" sx={{ display: 'inline-block', mt: 2, fontWeight: 600 }}>
          ← Back to Blog
        </MuiLink>
      </Container>
    </PublicPageLayout>
  );
}
